import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Alert, Button } from '@mui/material';

type OrganizeGeneralWorkbenchEntryProps = {
  visible: boolean;
};

const OrganizeGeneralWorkbenchEntry: React.FC<OrganizeGeneralWorkbenchEntryProps> = ({ visible }) => {
  if (!visible) {
    return null;
  }

  return (
    <Alert
      severity="info"
      className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between"
      data-testid="WORKBENCH_ORGANIZE_GENERAL_ENTRY"
    >
      <span>Review suggested groups in your General items without changing anything yet.</span>
      <Button
        component={RouterLink}
        to="/app/organize-general"
        variant="outlined"
        size="small"
        className="shrink-0"
      >
        Organize General
      </Button>
    </Alert>
  );
};

export default OrganizeGeneralWorkbenchEntry;
